export const VersionStatus = {
  Archived: 'archived',
  Draft: 'draft',
  PendingApproval: 'pending_approval',
  Published: 'published',
} as const;

export type VersionStatus =
  (typeof VersionStatus)[keyof typeof VersionStatus];
